import { IcInfoEmergency } from '@assets/icons/40x40';
import { Button, Center, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

type Props = {
  isVisible: boolean;
  onClick: () => void;
};

export default function ZoneApiError({ isVisible, onClick }: Readonly<Props>) {
  if (!isVisible) {
    return null;
  }
  return (
    <Center width="100%" height="100%" backgroundColor="neutral.700" position="absolute" zIndex={2}>
      <VStack width="100%" gap={4}>
        <HStack gap={2} alignItems="start">
          <Icon as={IcInfoEmergency} color="neutral.white" boxSize="40px" />
          <VStack gap={3} width="350px" alignItems="start">
            <Text>
              <FormattedMessage id="zone.errorTitle" />
            </Text>
            <Text whiteSpace="pre-line" textStyle="md">
              <FormattedMessage id="zone.errorSubTitle" />
            </Text>
          </VStack>
        </HStack>
        <Button type="button" onClick={onClick} width="120px">
          <FormattedMessage id="global.back" />
        </Button>
      </VStack>
    </Center>
  );
}
